import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import strings from "translate/language";
import { visitorDetail } from "reduxStore/action/visitorActions";
import {
  getAppointmentDetail,
  checkinAppointment,
  close_appointment,
  allocate_closingManager,
  remove_allocate,
} from "../../reduxStore/action/appointmentActions";
import {
  triggerWebhook,
  getSiteVisitStatusData,
  updateSiteVisitStatus,
} from "../../reduxStore/action/siteVisitActions";
import { getClosingManagerList } from "reduxStore/action/closingManagerAction";
import {
  getCPLeadType,
  handleDetailResponse,
  handleListResponse,
  isEmpty,
  seo,
} from "utils/utils";
import moment from "moment";
import { getMasterList } from "reduxStore/action/masterActions";
import { AppointmentStatus } from "utils/constants";
import Breadcrumb from "component/common/breadcrumb";
import usePermission from "utils/usePermission";
import {
  SupportRequest,
  ClosingManager,
  closing_head_id,
  ClosingTL,
  SourcingManager,
  SourcingTL,
  sourcing_head_id,
  SCM,
  SiteHead,
  BusinessHead,
  // AdminRoleId,
  // PostSale,
  // Receptionist,
  ClusterHead,
  admin_id,
  SourcingHead,
  MIS_RoleId,
} from "../../utils/constants";
import { errorToast, successToast } from "utils/httpClient";

const ViewAppointment = () => {
  const navigate = useNavigate();
  const [appointmentData, setAppointmentData] = useState({});
  const params = useParams();
  const { appointment_id = "" } = params || {};
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false); // State to control modal visibility
  const [showModals, setShowModals] = useState(false); // State to control modal visibility
  const [showNotInterestedModal, setShowNotInterestedModal] = useState(false);
  const [leadSourceType, setleadSourceType] = useState([]);
  const [comment, setComment] = useState("");
  const [leadScore, setLeadScore] = useState(0);
  const [reason, setSelectedReason] = useState([]);
  const [showBookNowModal, setShowBookNowModal] = useState(false);
  const [showFollowUpModal, setShowFollowUpModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedManager, setSelectedManager] = useState("");
  const [closingManagerList, setClosingManagerList] = useState([]);
  const [showWebhookModal, setShowWebhookModal] = useState(false);
  const [siteVisitMapping, setSiteVisitMapping] = useState(null);
  const [webhookLoading, setWebhookLoading] = useState(false);

  const closingManagerSelecter = useSelector((state) => state?.cmData);
  const siteVisitSelector = useSelector((state) => state?.siteVisit);

  const openModal = () => {
    setIsModalOpen(true);
    dispatch(
      getClosingManagerList({ property_id: appointmentData?.property_id }),
    );
  };

  // Handle closing the modal
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedManager(""); // Reset selected manager when closing
  };

  // Handle selection change
  const handleManagerChange = (e) => {
    setSelectedManager(e.target.value);
  };

  // Handle submitting the form
  const handleSubmit = () => {
    // You can add the submit logic here
    dispatch(
      allocate_closingManager({
        user_id: selectedManager,
        appointment_id: appointment_id,
      }),
    );
    closeModal();
  };

  // Function to handle opening the modal
  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleShowModals = () => setShowModals(true);
  const handleShowNotInt = () => {
    setShowNotInterestedModal(true);
  };

  // Function to handle closing the modal
  const handleCloseModal = () => {
    setShowModal(false);
    setShowNotInterestedModal(false);
    setShowBookNowModal(false);
    setShowFollowUpModal(false);
    setShowModals(false);
  };

  const leadSourceSelector = useSelector((state) => state.masterData);
  const appointmentDetailSelector = useSelector((state) => state.appointment);

  const allocateAppointmentSelector = useSelector(
    (state) => state.allocatedClosing,
  );

  const visitorDetailSelector = useSelector((state) => state.visitor);
  const navigatpage = async (navname) => {
    navigate(navname);
  };

  const { response: res } = useSelector((state) => state.login);

  const role_id = res?.data?.role_id;
  const CtTeam = ClosingTL === role_id;
  const misRole = MIS_RoleId === res?.data?.role_id;

  const CMTeam =
    ClosingTL === role_id ||
    ClosingManager === role_id ||
    closing_head_id === role_id;

  const SMteam =
    SourcingTL === role_id ||
    SourcingManager === role_id ||
    sourcing_head_id === role_id;

  const mixTeam =
    SCM === role_id ||
    SiteHead === role_id ||
    ClusterHead === role_id ||
    BusinessHead === role_id ||
    admin_id === role_id;

  const { edit, status, create, approve, isAdmin } = usePermission({
    edit: "close_appointment",
    status: "appointment_status_update",
    create: "book_now",
    approve: "ready_for_booking",
  });

  useEffect(() => {
    dispatch(visitorDetail({ lead_id: appointmentData.lead_id }));
  }, [dispatch, appointmentData]);

  useEffect(() => {
    dispatch(getAppointmentDetail({ appointment_id }));
    dispatch(getMasterList({ type: 8 }));
  }, [dispatch]);

  useEffect(() => {
    if (visitorDetailSelector.response) {
      const { response } = visitorDetailSelector;
      if (response?.status === 200) {
        setLeadScore(response?.data[0]?.lead_score);
      }
    }
  }, [visitorDetailSelector]);

  useEffect(() => {
    if (leadSourceSelector.response) {
      const { response } = leadSourceSelector;
      if (response?.status === 200) {
        setleadSourceType(handleListResponse(response.data));
      } else {
        setleadSourceType([]);
      }
    }
  }, [leadSourceSelector]);

  useEffect(() => {
    if (allocateAppointmentSelector.response) {
      const { response } = allocateAppointmentSelector;
      if (response?.status === 200) {
        successToast(response?.message);
        dispatch(getAppointmentDetail({ appointment_id }));
        dispatch(remove_allocate());
      } else {
        errorToast(response?.message);
      }
    }
  }, [allocateAppointmentSelector, appointment_id, dispatch]);

  useEffect(() => {
    if (appointmentDetailSelector.response) {
      const { response } = appointmentDetailSelector;
      if (response?.status === 200) {
        setAppointmentData(handleDetailResponse(response?.data));
      } else {
        setAppointmentData({});
      }
    }
  }, [appointmentDetailSelector]);

  // Fetch site visit mapping for LMS integration (optional - gracefully handles missing backend)
  useEffect(() => {
    if (appointment_id) {
      // Try with appointment_id first, backend will fallback to lead_id if needed
      // LMS Integration: Fetch site visit mapping data
      // Note: This will fail silently if LMS backend is not deployed yet
      dispatch(getSiteVisitStatusData({ appointment_id }))
        .then((res) => {
          if (res?.data && Array.isArray(res.data) && res.data.length > 0) {
            // LMS Integration: Log incoming site visit mapping data
            console.log("📥 [LMS] Site visit mapping received:", res.data[0]);
            setSiteVisitMapping(res.data[0]);
          } else {
            setSiteVisitMapping(null);
          }
        })
        .catch((err) => {
          // Silently handle missing LMS backend - this is expected if backend is not deployed yet
          setSiteVisitMapping(null);
        });
    }
  }, [appointmentData, appointment_id, dispatch]);

  const assign_role =
    appointmentData?.assign_appointment?.length > 0
      ? appointmentData?.assign_appointment[0]?.assign_by_role
      : "";

  const handleCheckin = () => {
    if (appointmentData?._id) {
      // Dispatch check-in action
      dispatch(checkinAppointment({ appointment_id: appointmentData._id }))
        .then(() => {
          // Send status update to LMS if mapping exists
          if (siteVisitMapping?.jv_site_visit_id) {
            const payload = {
              jvSiteVisitId: siteVisitMapping.jv_site_visit_id,
              status: "Visited",
              checkInTime: new Date().toISOString(),
              role: res?.data?.role_title || "auto",
            };

            // LMS Integration: Log outgoing check-in status update
            console.log(
              "📤 [LMS] Sending check-in status update:",
              JSON.stringify(payload, null, 2),
            );

            dispatch(updateSiteVisitStatus(payload))
              .then((res) => {
                if (res) {
                  successToast(
                    "Visitor checked in and LMS notified successfully",
                  );
                }
              })
              .catch((err) => {
                console.error("❌ [Frontend] Error updating LMS:", err);
              });
          }

          // After the check-in, re-fetch the appointment details
          dispatch(getAppointmentDetail({ appointment_id }));
        })
        .catch((error) => {
          // Error handled by Redux action
        });
    }
    handleCloseModal(); // Close the modal
  };

  const handleCloseAppointment = () => {
    if (appointmentData._id) {
      dispatch(
        close_appointment({
          lead_id: appointmentData.lead_id,
          appointment_id,
          appointment_status: 6,
          resion: reason._id,
          comment,
        }),
      )
        .then(() => {
          // Send closing status update to LMS if mapping exists
          if (siteVisitMapping?.jv_site_visit_id) {
            const payload = {
              jvSiteVisitId: siteVisitMapping.jv_site_visit_id,
              closingStatus: "Not Interested",
              role: res?.data?.role_title || "auto",
            };

            // LMS Integration: Log outgoing closing status update
            console.log(
              "📤 [LMS] Sending closing status update:",
              JSON.stringify(payload, null, 2),
            );

            dispatch(updateSiteVisitStatus(payload))
              .then((res) => {
                if (res) {
                  successToast("Closing status updated and LMS notified");
                  handleCloseModal();
                  dispatch(getAppointmentDetail({ appointment_id }));
                }
              })
              .catch((err) => {
                console.error("❌ [Frontend] Error updating LMS:", err);
              });
          } else {
            handleCloseModal();
            dispatch(getAppointmentDetail({ appointment_id }));
          }
        })
        .catch((error) => {
          // Error handled by Redux action
        });
    }
  };

  // Handle webhook trigger
  const handleTriggerWebhook = () => {
    if (siteVisitMapping?.jv_site_visit_id) {
      setWebhookLoading(true);
      dispatch(
        triggerWebhook({ jv_site_visit_id: siteVisitMapping.jv_site_visit_id }),
      )
        .then((res) => {
          if (res) {
            setShowWebhookModal(false);
            // Refresh appointment details
            dispatch(getAppointmentDetail({ appointment_id }));
          }
          setWebhookLoading(false);
        })
        .catch((err) => {
          // Error handled by Redux action
          setWebhookLoading(false);
        });
    } else {
      errorToast("Site visit mapping not found");
    }
  };

  const handleShowWebhookModal = () => {
    setShowWebhookModal(true);
  };

  const handleCloseWebhookModal = () => {
    setShowWebhookModal(false);
  };

  // Handle No Show - Send status to LMS
  const handleNoShow = () => {
    if (siteVisitMapping?.jv_site_visit_id) {
      const payload = {
        jvSiteVisitId: siteVisitMapping.jv_site_visit_id,
        status: "Not Visited",
        checkInTime: null,
        role: res?.data?.role_title || "auto",
      };

      // LMS Integration: Log outgoing no-show status update
      console.log(
        "📤 [LMS] Sending no-show status update:",
        JSON.stringify(payload, null, 2),
      );

      dispatch(updateSiteVisitStatus(payload))
        .then((res) => {
          if (res) {
            successToast("Marked as No Show and LMS notified");
            dispatch(getAppointmentDetail({ appointment_id }));
          }
        })
        .catch((err) => {
          // Error handled by Redux action
        });
    }
  };

  useEffect(() => {
    const { response = null, create = false } = closingManagerSelecter;
    if (response && response?.status === 200) {
      if (!create && response.data?.length > 0) {
        setClosingManagerList(
          handleListResponse(response?.data) ? response?.data : [],
        );
      }
    } else {
      setClosingManagerList([]);
    }
  }, [closingManagerSelecter]);

  useEffect(() => {
    seo({
      title: "Appointment Details",
      metaDescription: "Appoinment details",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.viewAppointmentDetails}
        url={"/appointment"}
        parentListing={strings.appointmentList}
        titleactive={strings.viewappointmentdetails}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0 d-flex justify-content-between">
                <h5>{strings.appointmentDetails}</h5>
                {CtTeam &&
                  (appointmentData?.status === 1 ||
                    appointmentData?.status === 10) && (
                    <button className="btn btn-primary" onClick={openModal}>
                      Allocate
                    </button>
                  )}
              </div>
              <div className="card-body">
                <div className="row ">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.visitorName} :
                    </label>
                  </div>
                  {/* <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {appointmentData?.customer_first_name === "" ||
                      appointmentData?.customer_first_name === undefined ||
                      appointmentData?.customer_first_name === null
                        ? strings.notavailable
                        : appointmentData?.customer_first_name}
                    </label>
                  </div> */}

                  <div className="col-md-7 align-items-center">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px", // spacing between name and tick
                      }}
                    >
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                        style={{ marginBottom: 0 }}
                      >
                        {(() => {
                          const firstName =
                            appointmentData?.customer_first_name || "";
                          const lastName =
                            appointmentData?.customer_last_name || "";
                          const fullName = `${firstName} ${lastName}`.trim();
                          return fullName || strings.notavailable;
                        })()}
                      </label>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row ">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.visitorScore} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {appointmentData?.lead_score}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row ">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.budget} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {appointmentData?.budget_amount
                        ? appointmentData?.budget_amount
                        : appointmentData?.min_budget &&
                            appointmentData?.max_budget
                          ? `${appointmentData?.min_budget}${appointmentData?.min_budget_type} - ${appointmentData?.max_budget}${appointmentData?.max_budget_type}`
                          : strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row ">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.expectedPossession} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {appointmentData?.expected_possession_period
                        ? appointmentData?.expected_possession_period
                        : appointmentData?.expected_possession_date === "" ||
                            appointmentData?.expected_possession_date ===
                              undefined ||
                            appointmentData?.expected_possession_date === null
                          ? strings.notavailable
                          : moment
                              .utc(appointmentData?.expected_possession_date)
                              .format("DD-MM-YYYY")}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-md-3 align-items-center ">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.configuration} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center ">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {appointmentData?.configuration || strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />

                <div className="row ">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.siteVisitTimeDate} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {moment(appointmentData?.appointment_date).format(
                        "YYYY-MM-DD",
                      ) || strings.notavailable}
                      {" & "} {appointmentData?.appointment_time}
                    </label>
                  </div>
                </div>
                <hr />

                <div className="row ">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.property} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {appointmentData?.property_title || strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />

                <div className="row ">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.closingStatus} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {Number(appointmentData?.status) === 1
                        ? moment() >=
                          moment(
                            moment(appointmentData.appointment_date).format(
                              "DD-MM-yyyy",
                            ) +
                              " " +
                              appointmentData.appointment_time,
                            "DD-MM-yyyy hh:mm A",
                          )
                          ? "Notvisited"
                          : "Upcoming"
                        : Number(appointmentData?.status) === 3
                          ? siteVisitMapping?.closing_status &&
                            siteVisitMapping.closing_status.trim() !== ""
                            ? siteVisitMapping.closing_status
                            : handleListResponse(
                                  appointmentData?.booking_status,
                                ).includes(1)
                              ? "Ready to Book"
                              : "Booking"
                          : AppointmentStatus[appointmentData?.status]}
                    </label>
                  </div>
                </div>
                <hr />

                <div className="row ">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.assignTo} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {appointmentData?.assign_appointment?.[0]?.user_name ||
                        strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row ">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.leadSource} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {appointmentData?.lead_source
                        ? appointmentData?.lead_source == "Reference" &&
                          appointmentData?.referrel_partner === 1
                          ? "Referral Partner"
                          : appointmentData?.lead_source
                        : strings.notfount}{" "}
                      {getCPLeadType(appointmentData?.cp_lead_type)}
                    </label>
                  </div>
                </div>
                <hr />
                {appointmentData?.lead_source == "Reference" && (
                  <>
                    <div className="row ">
                      <div className="col-md-3 align-items-center">
                        <label htmlFor="exampleInputMobileNo">
                          {strings.referrer} :
                        </label>
                      </div>
                      <div className="col-md-7 align-items-center">
                        <label
                          htmlFor="exampleInputMobileNo"
                          className="boldText"
                        >
                          {appointmentData?.referrer_name}
                        </label>
                      </div>
                    </div>
                    <hr />
                  </>
                )}
                {appointmentData?.lead_source == "Channel Partner" && (
                  <>
                    <div className="row ">
                      <div className="col-md-3 align-items-center">
                        <label htmlFor="exampleInputMobileNo">
                          {appointmentData.cp_type === 2
                            ? "CP Company Name"
                            : "CP Name"}{" "}
                          :
                        </label>
                      </div>
                      <div className="col-md-7 align-items-center">
                        <label
                          htmlFor="exampleInputMobileNo"
                          className="boldText"
                        >
                          {appointmentData?.cp_name
                            ? appointmentData?.cp_name
                            : strings.notavailable}
                        </label>
                      </div>
                    </div>
                    <hr />
                  </>
                )}
                {appointmentData?.cp_type === 2 && (
                  <>
                    <div className="row ">
                      <div className="col-md-3 align-items-center">
                        <label htmlFor="exampleInputMobileNo">
                          {strings.emname} :
                        </label>
                      </div>
                      <div className="col-md-7 align-items-center">
                        <label
                          htmlFor="exampleInputMobileNo"
                          className="boldText"
                        >
                          {appointmentData?.cp_emp_name
                            ? appointmentData?.cp_emp_name
                            : strings.notavailable}
                        </label>
                      </div>
                    </div>
                    <hr />
                  </>
                )}

                {!isEmpty(
                  handleDetailResponse(appointmentData?.checkin_status),
                ) && (
                  <>
                    <div className="row ">
                      <div className="col-md-3 align-items-center">
                        <label htmlFor="exampleInputMobileNo">
                          {strings.checkInStatus} :
                        </label>
                      </div>
                      <div className="col-md-7 align-items-center">
                        <label
                          htmlFor="exampleInputMobileNo"
                          className="boldText text-success"
                        >
                          {!isEmpty(
                            handleDetailResponse(
                              appointmentData?.checkin_status,
                            ),
                          )
                            ? "Visited"
                            : strings.notavailable}
                        </label>
                      </div>
                    </div>
                    <hr />
                  </>
                )}
                <div className="row ">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.reason} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {appointmentData?.resion || strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />

                <div className="row ">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.pickup} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {appointmentData?.pickup || strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />

                <div className="row ">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.pickupLocation}
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {appointmentData?.pickup_location || strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row ">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.noOfGuest}
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {appointmentData?.number_of_guest || strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />

                <div className="row ">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.created} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {appointmentData?.create_by || strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row ">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.createdByRole}
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {appointmentData?.created_by_role === "" ||
                      appointmentData?.created_by_role === undefined ||
                      appointmentData?.created_by_role === null
                        ? strings.notfount
                        : appointmentData?.created_by_role}
                    </label>
                  </div>
                </div>
                <hr />
                <div className="row ">
                  <div className="col-md-3 align-items-center">
                    <label htmlFor="exampleInputMobileNo">
                      {strings.remarkField} :
                    </label>
                  </div>
                  <div className="col-md-7 align-items-center">
                    <label htmlFor="exampleInputMobileNo" className="boldText">
                      {appointmentData?.remark || strings.notavailable}
                    </label>
                  </div>
                </div>
                <hr />
                {/* {edit &&
                  appointmentData?.status === 1 &&
                  isEmpty(
                    handleDetailResponse(appointmentData?.checkin_status)
                  ) ? (
                  <div className="row">
                    <div className="col-md-12 text-center">
                      <div className="card-footer">
                        <button
                          className="btn btn-color"
                          type="submit"
                          onClick={() => {
                            navigatpage(
                              `/update_appointment_status/${appointmentData?._id}`
                            );
                          }}
                        >
                          {strings.statusUpdate}
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )} */}
                <div className="row">
                  {CMTeam && (
                    <>
                      <div className={`col-md-6 d-flex justify-content-center`}>
                        <div className="card-footer">
                          <button
                            className="btn"
                            type="button"
                            style={{
                              backgroundColor: "white",
                              border: "1px solid #007bff", // Blue border
                              color: "#007bff", // Blue text color
                            }}
                            onClick={() => {
                              navigatpage(
                                `/visitor_form?lead_id=${appointmentData.lead_id}`,
                              );
                              localStorage.setItem(
                                "appointment_id",
                                appointmentData._id,
                              );
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#007bff"; // Blue background on hover
                              e.target.style.color = "white"; // White text on hover
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "white"; // Revert to white background
                              e.target.style.color = "#007bff"; // Revert to blue text
                            }}
                          >
                            {strings.updateVisitordetails}
                          </button>
                        </div>
                      </div>

                      <div className="col-md-6 d-flex justify-content-center">
                        <div className="card-footer">
                          <button
                            className="btn"
                            type="button"
                            style={{
                              backgroundColor: "white",
                              border: "1px solid #007bff", // Blue border
                              color: "#007bff", // Blue text color
                            }}
                            onClick={() =>
                              navigatpage(
                                `/allfollowup/${appointmentData.lead_id}`,
                              )
                            }
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = "#007bff"; // Blue background on hover
                              e.target.style.color = "white"; // White text on hover
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = "white"; // Revert to white background
                              e.target.style.color = "#007bff"; // Revert to blue text
                            }}
                          >
                            {strings.viewVisitorHistory}
                          </button>
                        </div>
                      </div>
                    </>
                  )}
                </div>
                {appointmentData?.checkin_status === true ||
                (Array.isArray(appointmentData?.checkin_status) &&
                  appointmentData?.checkin_status[0]?.status === true) ||
                // LMS integration: Include LMS status if available, but don't require it
                siteVisitMapping?.status === "Visited" ||
                siteVisitMapping?.status === "Completed" ||
                siteVisitMapping?.status === "Site Visit Done" ? (
                  <>
                    {(appointmentData?.status === 1 ||
                      appointmentData?.status === 10 ||
                      // LMS integration: If LMS data exists, check closing_status; otherwise use original logic
                      (Number(appointmentData?.status) === 3 &&
                        (!siteVisitMapping || // No LMS data = show buttons (fallback)
                          !siteVisitMapping?.closing_status ||
                          siteVisitMapping.closing_status.trim() === "")) ||
                      // LMS integration: If LMS status is "Visited" and no closing_status, show buttons
                      (siteVisitMapping &&
                        (siteVisitMapping?.status === "Visited" ||
                          siteVisitMapping?.status === "Completed" ||
                          siteVisitMapping?.status === "Site Visit Done") &&
                        (!siteVisitMapping?.closing_status ||
                          siteVisitMapping.closing_status.trim() === ""))) && (
                      <>
                        <div className="d-flex justify-content-center align-items-center mb-3 w-100">
                          {/* Close Appointment */}
                          {edit && !misRole && (
                            <button
                              className="btn btn-danger mx-2"
                              type="button"
                              style={{ flex: 1 }}
                              onClick={handleShowNotInt}
                            >
                              {strings.notInterested}
                            </button>
                          )}
                          {showNotInterestedModal && (
                            <div
                              className="modal fade show d-block"
                              tabIndex="-1"
                              role="dialog"
                              style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: "rgba(0, 0, 0, 0.5)",
                                backdropFilter: "blur(5px)",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                animation: "fadeIn 0.1s ease-in-out",
                              }}
                            >
                              <div
                                className="modal-dialog"
                                role="document"
                                style={{
                                  animation: "fadeIn 0.3s ease-in-out",
                                }}
                              >
                                <div className="modal-content">
                                  <div className="modal-header">
                                    <h5 className="modal-title">
                                      Close Appointment
                                    </h5>
                                    <button
                                      className="close"
                                      type="button"
                                      onClick={handleCloseModal} // Close the modal when clicked
                                      aria-label="Close"
                                    >
                                      <span aria-hidden="true">×</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                    <div className="form-group">
                                      {/* Dropdown for selecting the reason */}
                                      <label htmlFor="reasonSelect">
                                        Select Reason
                                      </label>
                                      <select
                                        id="reasonSelect"
                                        className="form-control"
                                        onChange={(e) =>
                                          setSelectedReason(e.target.value)
                                        } // Update state when selected
                                      >
                                        <option value="">Select Reason</option>
                                        {leadSourceType.map((item, index) => (
                                          <option
                                            key={item._id}
                                            value={item._id}
                                          >
                                            {item.title}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                    <div className="form-group">
                                      {/* Large text area for comments */}
                                      <label htmlFor="commentText">
                                        Enter Comment
                                      </label>
                                      <textarea
                                        id="commentText"
                                        className="form-control"
                                        rows="5"
                                        placeholder="Enter your comment"
                                        onChange={(e) =>
                                          setComment(e.target.value)
                                        } // Update comment state
                                      />
                                    </div>
                                  </div>
                                  <div className="modal-footer justify-content-center">
                                    <button
                                      className="btn btn-success mr-5"
                                      type="button"
                                      onClick={handleCloseAppointment} // Call handleCloseAppointment when Submit is clicked
                                    >
                                      Submit
                                    </button>
                                    <button
                                      className="btn btn-primary"
                                      type="button"
                                      onClick={handleCloseModal} // Close the modal when Cancel is clicked
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          {/* Update The Appointment Status */}
                          {status && !SMteam && !misRole && (
                            <button
                              className="btn btn-primary mx-2 "
                              type="button"
                              style={{ flex: 1 }}
                              onClick={() => {
                                navigatpage(`/revisit/${appointmentData?._id}`);
                              }}
                            >
                              {strings.revisit}
                            </button>
                          )}
                        </div>

                        <div className="d-flex justify-content-center align-items-center mb-3 w-100">
                          {/* Book Now */}
                          {create &&
                            !misRole &&
                            (res?.data?.role_id === ClosingManager ||
                              res?.data?.role_id === ClosingTL ||
                              res?.data?.role_id === closing_head_id ||
                              res?.data?.role_id === SourcingHead ||
                              res?.data?.role_id === ClusterHead ||
                              res?.data?.role_id === SiteHead ||
                              res?.data?.role_id === SCM) &&
                            // LMS integration: If LMS data exists, validate it; otherwise fallback to original logic
                            // This ensures "Book Now" works with OR without LMS backend
                            (!siteVisitMapping || // No LMS data = show button (fallback to original behavior)
                              // If LMS data exists, validate status and closing_status
                              ((siteVisitMapping?.status === "Visited" ||
                                siteVisitMapping?.status === "Completed" ||
                                siteVisitMapping?.status ===
                                  "Site Visit Done") &&
                                (!siteVisitMapping?.closing_status ||
                                  siteVisitMapping.closing_status.trim() ===
                                    "" ||
                                  siteVisitMapping.closing_status ===
                                    "Revisit"))) && (
                              <button
                                className="btn btn-primary mx-2 flex-grow-1"
                                type="button"
                                onClick={() => {
                                  if (leadScore > 70) {
                                    navigate(
                                      `/addBooking/${appointmentData.lead_id}/${appointment_id}`,
                                    ); // Navigates to the booking page if leadScore is greater than 70
                                  } else {
                                    // Optionally, you can show an alert or perform any other action if the condition is not met
                                    handleShowModals();
                                  }
                                }}
                              >
                                {strings.bookNow}
                              </button>
                            )}
                          {showModals && (
                            <div
                              className="modal fade show d-block"
                              tabIndex="-1"
                              role="dialog"
                              style={{
                                position: "fixed",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: "rgba(0, 0, 0, 0.5)", // Dark background with transparency
                                backdropFilter: "blur(5px)", // Background blur effect
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                animation: "fadeIn 0.1s ease-in-out", // Animation for fade-in effect
                              }}
                            >
                              <div
                                className="modal-dialog"
                                role="document"
                                style={{
                                  animation: "fadeIn 0.3s ease-in-out", // Animation for modal content
                                }}
                              >
                                <div className="modal-content">
                                  <div className="modal-header">
                                    <h5 className="modal-title">
                                      Low Visitor Score
                                    </h5>
                                    <button
                                      className="close"
                                      type="button"
                                      onClick={handleCloseModal} // Close the modal when clicked
                                      aria-label="Close"
                                    >
                                      <span aria-hidden="true">×</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                    <div className="text-center">
                                      <h6>
                                        Visitor Score less than 70, please
                                        update visitor information.
                                      </h6>
                                    </div>
                                  </div>
                                  <div className="modal-footer justify-content-center">
                                    <button
                                      className="btn btn-primary"
                                      type="button"
                                      onClick={handleCloseModal} // Close the modal when Cancel is clicked
                                    >
                                      {strings.cancel}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Follow Up */}
                          {!misRole && (
                            <button
                              className="btn btn-primary mx-2 flex-grow-1"
                              type="button"
                              onClick={() => {
                                const url = appointment_id
                                  ? `/updatestatusfollow/${appointmentData.lead_id}/${appointment_id}`
                                  : `/updatestatusfollow/${appointmentData.lead_id}`;
                                navigatpage(url);
                              }}
                              style={{
                                display: !SMteam ? "inline-block" : "none",
                              }}
                            >
                              {strings.followUp}
                            </button>
                          )}
                        </div>
                      </>
                    )}
                  </>
                ) : appointmentData?.status === 1 ? (
                  res?.data?.role_title === "SCM" ? (
                    assign_role === "SCM" && (
                      <div className="d-flex justify-content-center align-items-center mb-3">
                        {/* Status Update */}
                        {!misRole && (
                          <button
                            className="btn btn-primary mx-2"
                            type="button"
                            onClick={handleNoShow}
                          >
                            {strings.noShow}
                          </button>
                        )}

                        {/* Checked In */}
                        <button
                          className="btn btn-secondary mx-2"
                          type="button"
                          onClick={handleShowModal}
                        >
                          {strings.visitorCheckin}
                        </button>
                        {showModal && (
                          <div
                            className="modal fade show d-block"
                            tabIndex="-1"
                            role="dialog"
                            style={{
                              position: "fixed",
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              backgroundColor: "rgba(0, 0, 0, 0.5)", // Dark background with transparency
                              backdropFilter: "blur(5px)", // Background blur effect
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              animation: "fadeIn 0.1s ease-in-out", // Animation for fade-in effect
                            }}
                          >
                            <div
                              className="modal-dialog"
                              role="document"
                              style={{
                                animation: "fadeIn 0.3s ease-in-out", // Animation for modal content
                              }}
                            >
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title">
                                    {strings.confirmCheckin}
                                  </h5>
                                  <button
                                    className="close"
                                    type="button"
                                    onClick={handleCloseModal} // Close the modal when clicked
                                    aria-label="Close"
                                  >
                                    <span aria-hidden="true">×</span>
                                  </button>
                                </div>
                                <div className="modal-body">
                                  <div className="text-center">
                                    <h6>{strings.confirmCheckin}</h6>
                                  </div>
                                  {/* <div className="text-center">
            <h6>{strings.youWantChangePassword}</h6>
          </div> */}
                                </div>
                                <div className="modal-footer justify-content-center">
                                  <button
                                    className="btn btn-success mr-5"
                                    type="button"
                                    onClick={handleCheckin} // Call handleCheckin when Yes is clicked
                                  >
                                    {strings.yes}
                                  </button>
                                  <button
                                    className="btn btn-primary"
                                    type="button"
                                    onClick={handleCloseModal} // Close the modal when No is clicked
                                  >
                                    {strings.no}
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    )
                  ) : (
                    <div className="d-flex justify-content-center align-items-center mb-3">
                      {/* Status Update */}
                      {!misRole && (
                        <button
                          className="btn btn-primary mx-2"
                          type="button"
                          onClick={
                            SMteam
                              ? () =>
                                  navigatpage(
                                    `/update_appointment_status/${appointmentData?._id}`,
                                  )
                              : handleNoShow
                          }
                        >
                          {SMteam ? strings.statusUpdate : strings.noShow}
                        </button>
                      )}

                      {/* Checked In */}
                      {!SMteam && !misRole && (
                        <button
                          className="btn btn-secondary mx-2"
                          type="button"
                          onClick={handleShowModal}
                        >
                          {strings.visitorCheckin}
                        </button>
                      )}
                      {showModal && (
                        <div
                          className="modal fade show d-block"
                          tabIndex="-1"
                          role="dialog"
                          style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: "rgba(0, 0, 0, 0.5)", // Dark background with transparency
                            backdropFilter: "blur(5px)", // Background blur effect
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            animation: "fadeIn 0.1s ease-in-out", // Animation for fade-in effect
                          }}
                        >
                          <div
                            className="modal-dialog"
                            role="document"
                            style={{
                              animation: "fadeIn 0.3s ease-in-out", // Animation for modal content
                            }}
                          >
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title">
                                  {strings.confirmCheckin}
                                </h5>
                                <button
                                  className="close"
                                  type="button"
                                  onClick={handleCloseModal} // Close the modal when clicked
                                  aria-label="Close"
                                >
                                  <span aria-hidden="true">×</span>
                                </button>
                              </div>
                              <div className="modal-body">
                                <div className="text-center">
                                  <h6>{strings.confirmCheckin}</h6>
                                </div>
                                {/* <div className="text-center">
            <h6>{strings.youWantChangePassword}</h6>
          </div> */}
                              </div>
                              <div className="modal-footer justify-content-center">
                                <button
                                  className="btn btn-success mr-5"
                                  type="button"
                                  onClick={handleCheckin} // Call handleCheckin when Yes is clicked
                                >
                                  {strings.yes}
                                </button>
                                <button
                                  className="btn btn-primary"
                                  type="button"
                                  onClick={handleCloseModal} // Close the modal when No is clicked
                                >
                                  {strings.no}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {showFollowUpModal && (
                        <div
                          className="modal fade show d-block"
                          tabIndex="-1"
                          role="dialog"
                          style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: "rgba(0, 0, 0, 0.5)", // Dark background with transparency
                            backdropFilter: "blur(5px)", // Background blur effect
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            animation: "fadeIn 0.1s ease-in-out", // Animation for fade-in effect
                          }}
                        >
                          <div
                            className="modal-dialog"
                            role="document"
                            style={{
                              animation: "fadeIn 0.3s ease-in-out", // Animation for modal content
                            }}
                          >
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title">
                                  {strings.confirmCheckin}
                                </h5>
                                <button
                                  className="close"
                                  type="button"
                                  onClick={handleCloseModal} // Close the modal when clicked
                                  aria-label="Close"
                                >
                                  <span aria-hidden="true">×</span>
                                </button>
                              </div>
                              <div className="modal-body">
                                <div className="text-center">
                                  <h6>{strings.confirmCheckin}</h6>
                                </div>
                                {/* <div className="text-center">
            <h6>{strings.youWantChangePassword}</h6>
          </div> */}
                              </div>
                              <div className="modal-footer justify-content-center">
                                <button
                                  className="btn btn-success mr-5"
                                  type="button"
                                  onClick={handleCheckin} // Call handleCheckin when Yes is clicked
                                >
                                  {strings.yes}
                                </button>
                                <button
                                  className="btn btn-primary"
                                  type="button"
                                  onClick={handleCloseModal} // Close the modal when No is clicked
                                >
                                  {strings.no}
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  )
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <div
          className="modal"
          tabIndex="-1"
          style={{
            display: "block",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
            backdropFilter: "blur(5px)", // Apply the blur effect to the background
            zIndex: 1050, // Ensure the modal is above other content
          }}
        >
          <div
            className="modal-dialog"
            style={{
              position: "relative",
              margin: "10% auto",
              backgroundColor: "white",
              borderRadius: "8px",
              padding: "20px",
              maxWidth: "500px",
            }}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{strings.allocate}</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={closeModal}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <label htmlFor="closingManager">
                    {strings.selectNewClosingManager}
                  </label>
                  <select
                    id="closingManager"
                    className="form-control"
                    value={selectedManager}
                    onChange={handleManagerChange}
                  >
                    <option value="">Select</option>
                    {/* Map through closingManagerList */}
                    {closingManagerList.map((manager) => (
                      <option key={manager.user_id} value={manager.user_id}>
                        {manager.user_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeModal}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default ViewAppointment;
